import React, { useEffect } from 'react';
import Footer from './Footer';
import Header from './Header';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import confetti from 'canvas-confetti';

const OrderConfirmation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    // Left cannon
    confetti({
      particleCount: 180,
      angle: 60,
      spread: 150,
      origin: { x: 0, y: 0.8 },
      gravity: 0.4,
    });

    // Right cannon
    confetti({
      particleCount: 180,
      angle: 120,
      spread: 150,
      origin: { x: 1, y: 0.8 },
      gravity: 0.4,
    });
  }, []);

  return (
    <CheckoutWrapper>
      <Header />
      <ConfirmationMessage>
        <Title>{t('orderConfirmation.thankYouTitle')}</Title>
        <P>{t('orderConfirmation.thankYouLine1')}</P>
        <P>{t('orderConfirmation.thankYouLine2')}</P>
        <P>{t('orderConfirmation.thankYouLine3')}</P>
        <P dangerouslySetInnerHTML={{ __html: t('orderConfirmation.thankYouLine4') }} />
        <Button onClick={() => navigate('/')}>
          {t('orderConfirmation.backHome')}
        </Button>
      </ConfirmationMessage>
      <Footer />
    </CheckoutWrapper>
  );
};

export default OrderConfirmation;

const CheckoutWrapper = styled.div`
background: linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);
`

const ConfirmationMessage = styled.div`

  background-color: rgba(255, 255, 255, 0.7);
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin: 220px auto;
  max-width: 700px;
  text-align: center;

  h1 {
    font-size: 2rem;
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    color: #555;
    margin: 0.5rem 0;
  }

  a {
    color: #d97961;
    text-decoration: underline;
    font-weight: 500;
  }
`;

const P = styled.p`
font-size: 21px;
`

const Title = styled.p`
font-size: 60px;
  font-family: 'Great Vibes', cursive;
`

const Button = styled.button`
padding: 10px;
background-color: rgba(217,121,97,1);
color: white;
border: none;
box-shadow: 0 4px 24px grey;
font-size: 18px;
border-radius: 10px;
margin: 20px auto;
cursor: pointer;
&:hover {
    background-color:rgb(180, 108, 90);
  }
`